import dayjs from 'dayjs';

export class FilesClass {
  idCustomerFilesDriveLicense: number | null = null;
  idCustomerFilesCitizenCard: number | null = null;
  idInsurancePolicyDocuments: number | null = null;
  idInsurancePolicy: number | null = null;
  idSafeSimulationsDocuments: number | null = null;
  idSafeSimulations: number | null = null;
  idSafeSimulationsFileStructure: number | null = null;
  idSafeSimulationsMessage: number | null = null;
  idSafeSimulationsMessagesFiles: number | null = null;
  idProductsTypesProposalsDetailsFiles: number | null = null;
  idProductsTypesProposalsDetails: number | null = null;
  idProductsTypesClaimsCausesPDF: number | null = null;
  idProductsTypesPurchasePDF: number | null = null;
  idInsuranceClaimsQuizConfigPDF: number | null = null;
  idProductsTypesProposals: number | null = null;
  idCompanie: number | null = null;
  idProduct: number | null = null;
  idProductsTypes: number | null = null;
  idProductsClaimsCompanies: number | null = null;
  idMessageCenterTransactionFiles: number | null = null;
  idMessageCenterTransaction: number | null = null;
  idMessageCenterTransactionDetail: number | null = null;
  idCustomer: number | null = null;
  Description: string = '';
  DocumentName: string = '';
  updated: Date | null = null;
  FilePath: string = '';
  type: string = '';
  size: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Tooltip: string = '';
  Order: number | null = null;
  SendEmailTo: string = '';
  cc: string = '';
  bcc: string = '';
  SendSMSTo: string = '';
  subject: string = '';
  html: string = '';
  ManagedBySegurosVirtual: boolean = false;
  selected: boolean = false;
  isWaitFile: boolean = false;
  Tabulador: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
  VirtualDoc: boolean = false;
  documentId: string = '';
  PolicyNumber: string = '';
  NrRecibo: string = '';
  ValorRecibo: string = '';
  Tipo: string = '';
  HideFromClients: boolean = false; // TINYINT, using number here for simplicity
  AttributeExtension1: string = '';
  AttributeExtension2: string = '';
  AttributeExtension3: string = '';
  AttributeExtension4: string = '';
  AttributeExtension5: string = '';
  AttributeExtension6: string = '';
  previewURL?: string; // Novo campo para armazenar a URL da pr\u00e9-visualiza\u00e7\u00e3o
  fileURL?: string; // Adiciona esta propriedade para armazenar o URL do ficheiro
  isHovered: boolean = false;
  showPreview?: boolean;
  originalFile?: File;
  isTemporary?: boolean; // Marca documentos temporários (antes de guardar cotação)
  previewType?: 'image' | 'text' | 'error'; // Tipo de pré-visualização
  previewContent?: string; // Conteúdo de texto para pré-visualização
  loadingPreview?: boolean; // Indicador de carregamento da pré-visualização
  aiMetadata?: any; // Armazenar metadados da IA (parseado do AttributeExtension1)

  constructor(init?: Partial<FilesClass>) {
    if (init) {
      Object.assign(this, init);
    }
  }

  public parseDates() {
    const dateFields = ['updated', 'DateStart', 'DateEnd'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });
  }
}

export class UploadFilesClass {
  idCustomer: number | null = null;
  NIF: string = '';
  idCompanie: number | null = null;
  idProduct: number | null = null;
  idProductsTypes: number | null = null;
  idProductsClaimsCompanies: number | null = null;
  TitleForm: string = '';
  FolderName: string = '';
  maxAllowedfiles: number | null = null;
  maxAllowedSize: number | null = null;
  filesClass: FilesClass[] = [];
  HidephotoButton: boolean = false;
  comment: string = '';
  originalFile?: File;
  contextType: 'clientarea' | 'intermediaryarea' | 'commercialarea' = 'clientarea'; // Controlar o tipo de comportamento com base no contexto
  customerName?: string;
  policyNumber?: string;
  idInsurancePolicy?: number | null;
}

export class FilesStructure {
  idFilesStructure: number | null = null;
  idProduct: number | null = null;
  idProductsTypes: number | null = null;
  Source: string = '';
  Name: string = '';
  Value: string = '';
  Tooltip: string = '';
  AGEASCodes: string = '';
  TranquilidadeCodes: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  Icon: string = '';
  Others: boolean = false;
  UUID: string = '';
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = ['DateStart', 'DateEnd'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });
  }
}

export class DownloadedFile {
  document: string;
  name: string;
  contentType: string;
  status: any;
  statusCode: any;

  constructor(data: any) {
    this.document = data.document || '';
    this.name = data.name || '';
    this.contentType = data.contentType || '';
    this.status = data.status || null;
    this.statusCode = data.statusCode || null;
  }
}
